import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import "react-loading-skeleton/dist/skeleton.css";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": { marginTop: 0 },
    },
    systemLogsLink: {
      marginTop: theme.spacing(8),
      fontSize: 14,
      fontWeight: 500,
      color: theme.primary500,
    },
    oltable: {
      border: "1px solid rgba(224, 224, 224, 1)",
      "& > table": { paddingBottom: 0 },
    },
    modalButton: {
      height: theme.spacing(24),
      marginTop: theme.spacing(12),
    },
    modalInput: {
      maxWidth: "100%",
      width: 406,
      "& + &": { marginTop: theme.spacing(10) },
    },
  }),
);
